import React from 'react';
import { Flex } from '../Flex';
import { PillsRating } from '../PillsRating';
import { Link } from '../Link';
export type HealthRatingValue = {
  score: number;
  severityLabel: string;
};
type Props = {
  value: HealthRatingValue;
};
export const HealthRating = ({
  value: {
    score,
    severityLabel
  }
}: Props) => <Flex height="24px" mt={['8px', 0]} data-sentry-element="Flex" data-sentry-component="HealthRating" data-sentry-source-file="index.tsx">
    <Flex alignItems="flex-end" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <PillsRating value={score} data-sentry-element="PillsRating" data-sentry-source-file="index.tsx" />
    </Flex>
    <Link href="#advice" color="wagGreen" fontWeight="bold" m={0} pl="8px" data-sentry-element="Link" data-sentry-source-file="index.tsx">
      {severityLabel}
    </Link>
  </Flex>;
export type HealthRatingProps = Props;